import { TextArea } from "devextreme-react/text-area";
import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import { useContext, useRef, useState } from "react";
import { Field } from "../../../../layouts";
import { RetailOrderContext } from "../context/RetailOrderContext";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useReleaseRetailOrderFromPending } from "../api/release-retail-order-from-pending";
import { LoadPopupPanel } from "../../../../components";

export default function ReleaseFromPendingButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const commentRef = useRef<TextArea>(null);

	const releaseFromPending = useReleaseRetailOrderFromPending(
		() => {
			setPopupVisibility(false);
			showSuccessMessage('The order has been released from pending.');
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	)

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-release-ro-from-pending' }}
				text="Release from Pending"
				icon="Inscyth-Change-Orders"
				className="release-from-pending-button"
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			<Popup
				title="Release From Pending"
				width={600}
				height={450}
				visible={isPopupVisible}
				hideOnOutsideClick={true}
				onHiding={() => setPopupVisibility(false)}
			>
				<ToolbarItem
					options={{
						icon: 'dx-icon dx-icon-close',
						onClick: function () {
							setPopupVisibility(false);
						}
					}}
					widget="dxButton"
					location="after"
				/>
				<div className="release-from-pending-popup-content">
					<div className="static-text">
						Please confirm that you want to proceed with releasing from pending.
					</div>
					<Field label={'Comment'} vertical={true} className="black-label">
						<TextArea ref={commentRef} height={200} className="required">
							<Validator validationGroup="releaseFromPendingGroup">
								<RequiredRule message={'Comment is required'} />
							</Validator>
						</TextArea>
					</Field>
				</div>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Submit',
						validationGroup: 'releaseFromPendingGroup',
						onClick: (e: any) => {
							if (e.validationGroup.validate().isValid) {
								releaseFromPending.mutate({
									retailOrderID: order.details.retailOrderID,
									comment: commentRef.current?.instance.option("value")!
								});
							}
						}
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<ToolbarItem
					options={{
						type: 'normal',
						stylingMode: 'contained',
						text: 'Cancel',
						onClick: () => setPopupVisibility(false)
					}}
					toolbar={'bottom'}
					widget="dxButton"
					location="after"
				>
				</ToolbarItem>
				<LoadPopupPanel visible={releaseFromPending.isLoading} />
			</Popup>
		</>
	)
}
